import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#badge" }),
    /*#__PURE__*/_createTextVNode(" Badge ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " A number or status mark on buttons and icons. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasicUsage = _resolveComponent("EUIBasicUsage")
  const _component_EUIMaxValue = _resolveComponent("EUIMaxValue")
  const _component_EUICustomizations = _resolveComponent("EUICustomizations")
  const _component_EUILittleRedDot = _resolveComponent("EUILittleRedDot")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasicUsage),
    _createVNode(_component_EUIMaxValue),
    _createVNode(_component_EUICustomizations),
    _createVNode(_component_EUILittleRedDot)
  ], 64))
}